export default "__VITE_ASSET__CagVq4Ik__"